"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderWithLoadProgress = renderWithLoadProgress;
exports.LoadingClassName = void 0;

require("core-js/modules/es6.object.assign");

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * WARNING: Do _not_ change this element to something common like a div. If the
 * element of this container is the same as the element used in the RelayContainer
 * then rehydration can fail and cause the RelayContainer to receive styles
 * from the SpinnerContainer and Spinner.
 */
var SpinnerContainer = _styledComponents.default.figure.withConfig({
  displayName: "renderWithLoadProgress__SpinnerContainer",
  componentId: "sc-1i7p8yh-0"
})(["width:100%;height:100px;position:relative;"]);

var LoadingClassName = "relay-loading";
exports.LoadingClassName = LoadingClassName;

function renderWithLoadProgress(Container) {
  var initialProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // TODO: We need design for retry-ing, or the go-ahead to re-use the design of
  //       the iOS app.
  //
  // let retrying = false
  return function (_ref) {
    var error = _ref.error,
        props = _ref.props,
        retry = _ref.retry;

    if (error) {
      // In tests we want errors to clearly bubble up.
      if (typeof jest !== "undefined") {
        throw error;
      }

      var networkError = error;

      if (error.message) {
        console.error(error.message);
      }

      if (networkError.response && networkError.response._bodyInit) {
        var data = networkError.response._bodyInit;

        if (data) {
          try {
            data = JSON.parse(data);
            console.error("Metaphysics Error data:", data); // tslint:disable-next-line:no-empty
          } catch (e) {}
        }
      } // if (retrying) {
      //   retrying = false
      //   // TODO: Even though this code path is reached, the retry button keeps spinning. iirc it _should_ disappear when
      //   //      `onRetry` on the instance is unset.
      //   //
      //   // This will re-use the native view first created in the renderFailure callback, which means it can
      //   // continue its ‘retry’ animation.
      //   return <LoadFailureView style={{ flex: 1 }} />
      // } else {
      //   retrying = true
      //   return <LoadFailureView onRetry={retry} style={{ flex: 1 }} />
      // }


      return null;
    } else if (props) {
      return _react.default.createElement(Container, _extends({}, initialProps, props));
    } else {
      return _react.default.createElement(SpinnerContainer, {
        className: LoadingClassName
      }, _react.default.createElement(_palette.Spinner, null));
    }
  };
}
//# sourceMappingURL=renderWithLoadProgress.js.map